
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import { feesChange, logInfo } from '@/api/ordercenter'
import Log from './detail/log.vue'
import util from '@/utils/busi/util'

@Component({
  name: 'feelog',
  components: {
    SimpleTable,
    Log
  }
})

export default class FeeLog extends Vue {
  private params = util.getRouterParams()

  private tableData = {
    list: [],
    totalCount: 0
  }

  private pagination = {
    currentPage: 1,
    pageSize: 10
  }

  private loading = !1

  private columns = [
    {
      prop: 'userAlias',
      label: '操作账号'
    },
    {
      prop: 'createName',
      label: '操作人员'
    },
    {
      prop: 'oldSchoolName',
      label: '变更前院校'
    },
    {
      prop: 'oldGradeName',
      label: '变更前年级'
    },
    {
      prop: 'oldSubjectName',
      label: '变更前专业'
    },
    {
      prop: 'schoolName',
      label: '变更后院校'
    },
    {
      prop: 'gradeName',
      label: '变更后年级'
    },
    {
      prop: 'subjectName',
      label: '变更后专业'
    },
    {
      prop: 'createTime',
      label: '操作日期',
      format: 'date'
    }
  ]

  beforeMount () {
    this.initData()
  }

  private async initData (pagination: any = null) {
    await feesChange({
      signupId: this.params.id,
      ...pagination || this.pagination
    }).then(async (res: any) => {
      if (res.code === 10000) {
        this.tableData.list = res.object.list
        this.tableData.totalCount = res.object.totalCount
      }
    })
  }

  private detailData = {}

  private dialogVisible = !1

  private rowDbClick (row: any) {
    this.showDetail(row)
  }

  private async showDetail (row: any) {
    await logInfo({
      id: row.id
    }).then((res: any) => {
      if (res.code === 10000) {
        this.detailData = res.object
      }
    })
    this.dialogVisible = !0
  }

  private closeDialog () {
    // do
  }
}
